// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import SelectPresentationPropsDefault from "@insite/mobius/Select/presentationProps";
import { SelectProps } from "@tps/MobiusOverrides/Select";
import IconDropdownDown from "@tps/XDL/Icons//IconDropdownDown";
import { xBaseTheme } from "@tps/XDL/types";
import { color } from "@tps/XDL/Utilities";
import { css } from "styled-components";

export const pdpIconStyle: SelectProps = {
    mergeCss: true,
    css: css`
        &&[aria-expanded="true"] ~ ${IconWrapper} {
            transform: unset;
            padding: 5px;
            svg {
                transform: rotate(180deg);
            }
        }
    `,
    iconProps: {
        mergeCss: true,
        css: css`
            &&& {
                border-radius: 0;
                background-color: ${color("common.ui2")};
                right: 0;
                top: 0;
                border: 1px solid ${color("common.ui5")};
                height: 100%;
                svg {
                    transition: all 200ms ease-in-out;
                    path {
                        fill: ${color("primary.main")};
                    }
                }
            }
        `,
    },
};

export default {
    defaultProps: {
        ...SelectPresentationPropsDefault,
        mergeCss: true,
        iconProps: {
            src: IconDropdownDown,
            size: 13,
            color: `${color("common.ui5")}`,
            css: css`
                &&& {
                    display: flex;
                    justify-content: flex-end;
                    padding-right: 13px;
                    width: auto;
                }
                svg {
                    width: 8px;
                    height: 13px;
                }
            `,
        },
        css: css`
            &&[aria-expanded="true"] ~ ${IconWrapper} {
                transform: rotate(180deg);
                padding-right: 5px;
                padding-left: 13px;
            }
        `,
    },
} as xBaseTheme["select"];
